
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { NavDropdown, MenuItem } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import NavBarMenuItem from '../../common/navbar/NavBarMenuItem.js';

/**
 * Note: Your components tell React what you want to render
 */
class AppNavBarOrganizations extends React.Component {
	render() {
		return (
      <NavDropdown eventKey={this.props.eventKey} title="Organizations" id="nav-dropdown">
        <NavBarMenuItem eventKey={this.props.eventKey + ".1"} glyph="stop" href="https://en.wikipedia.org/wiki/Freemasonry"> Freemason Fraternity</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".2"} glyph="leaf" href="http://www.pikapp.org/"> Pi Kappa Phi Fraternity</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".3"} glyph="book" href="http://phisigmatau.org/"> Phi Sigma Tau Honor Society</NavBarMenuItem>
         <NavBarMenuItem eventKey={this.props.eventKey + ".3"} glyph="star" href="https://sar.org/"> Sons of the American Revolution (NSSAR)</NavBarMenuItem>
        <MenuItem divider />
        <NavBarMenuItem eventKey={this.props.eventKey + ".4"} glyph="cog" href="https://www.amia.org/"> American Medical Informatics Association</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".5"} glyph="edit" href="https://acdm.org/"> Association for Configuration and Data Management</NavBarMenuItem>
      </NavDropdown>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default AppNavBarOrganizations;



// WEBPACK FOOTER //
// ./src/cba/appspec/header/Nav_AppNavBar_Organizations.js